import React from 'react';
import PropTypes from 'prop-types';
import SectionHeader, { SectionHeaderTypes } from './SectionHeader';

function SectionHeaderWithIcon({ sectionName, truncateName=false, sectionIcon, sectionHeaderType = SectionHeaderTypes.Primary, classes, children }) {

    let truncateNameClass = truncateName ? "truncate" : "";
    return (<SectionHeader sectionHeaderType={sectionHeaderType} classes={classes}>
        <div className={truncateNameClass}>
            <i className={`${sectionIcon} mr-1 text-2xl`} />
            <span className="sectionName">{sectionName}</span>
        </div>
        {children}
    </SectionHeader>);
}

SectionHeaderWithIcon.propTypes = {
    truncateName: PropTypes.bool,
}

export { SectionHeaderWithIcon as default, SectionHeaderTypes }